import "./index.less";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { useEffect, useImperativeHandle, useState } from "react";
import ContextMenuWrapper from "@/commons/widget/context-menu/context-menu-wrapper";
import {Input } from "antd";
import { ParamNameUtil, ParamUnits } from "@/commons/utils/unit";
import './material-detail.less';
import { floatVerification } from "@/commons/utils/antd-input";

interface IProps {
    material: PMaterial
    width: number;
    goBack: () => void
    onUpdate: (material: PMaterial, params: { name: string; value: string; key: string; }[]) => void
}
export default function MaterialDetail(props: IProps, ref) {
    const { material } = props;
    const [newMaterial, setNewMaterial] = useState<PMaterial>({ ...material }); // 修改后材料

    const [params, setParams] = useState<{ name: string, value: string, key: string }[]>([]); // 修改后材料

    useImperativeHandle(ref, () => ({
        handleInsert: () => props.onUpdate(newMaterial, params),
    }))

    useEffect(() => {
        if (newMaterial) {
            let tmpParams: { name: string, value: string, key: string }[] = [];
            Object.keys(newMaterial.params).forEach(key => {
                if (ParamNameUtil[key] && ParamUnits[key] && Object.prototype.hasOwnProperty.call(newMaterial.params, key)) {
                    // 修改后的name赋值逻辑
                    let name = ParamNameUtil[key] || "";
                    if (ParamUnits[key]) {
                        name += ` (${ParamUnits[key]})`;
                    }
                    let value = (newMaterial.params[key] / 1000 / 1000).toString();
                    tmpParams.push({ name: name, value: value, key: key });
                }
            })
            setParams(tmpParams);
        }
    }, [newMaterial])

    const handleChangeParams = (key: string, value: string) => {
        // const newValue = parseFloat(value);
        let tmpParams = params.map(param => {
            if (param.name === key) {
                return { value: floatVerification(value), name: param.name, key: param.key }
            } else {
                return { value: param.value, name: param.name, key: param.key }
            }
        })
        setParams(tmpParams);
    }

    return (
        <div className="material-detail" style={{ width: props.width - 32 - 4 }}>
            <div className="common-box name-box">
                <div className="name-item">
                    <div className="name-item-title">名称</div>
                    <Input
                        placeholder="请输入名称"
                        value={newMaterial?.name}
                        onChange={(e) => {
                            setNewMaterial({ ...newMaterial, name: e.target.value });
                        }}
                    ></Input>
                </div>
                <div className="name-item">
                    <div className="name-item-title">类型</div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">{newMaterial?.categoryName}</div>
                                {/* <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                /> */}
                            </div>
                        }
                        visible={false}
                        classname="select-area"
                        width={props.width - 32 - 4} />
                </div>
                <div className="name-item">
                    <div className="name-item-title">标准</div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">
                                    {newMaterial?.code}
                                </div>
                                {/* <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                /> */}
                            </div>
                        }
                        visible={false}
                        classname="select-area"
                        width={props.width - 32 - 4} />
                </div>
                <div className="name-item">
                    <div className="name-item-title">
                        {newMaterial?.categoryName}等级
                    </div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">
                                    {newMaterial?.mark}
                                </div>
                                {/* <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                /> */}
                            </div>
                        }
                        visible={false}
                        classname="select-area"
                        width={props.width - 32 - 4} />
                </div>
            </div>
            <div className="common-box param-box">
                <div className="param-box-title">材料参数</div>
                {params?.map(param => {
                    return (
                        <div className="param-item" key={param.name}>
                            <div className="param-item-title">
                                {param.name}
                            </div>
                            <Input
                                placeholder={`请输入`}
                                value={param.value} // 显示调整后的值
                                onChange={(e) => handleChangeParams(param.name, e.target.value)}
                            />
                        </div>

                    )
                })}

            </div>
            {/* <div className='footer'>
                <Button className='btn add' onClick={() => props.onUpdate(newMaterial)}>确认</Button>
                <Button className='btn cancel' onClick={() => props.goBack()}>取消</Button>
            </div> */}
            {/* <div className='bottom-footer'>
                <Button className='btn-save' onClick={() => props.onUpdate(newMaterial, params)}>确认</Button>
                <Button className='btn-cancel' onClick={() => props.goBack()}>取消</Button>
            </div> */}
        </div>
    )
}